import verticalLine from './vertikal.svg';
import horizontalLine from './horizontal-w-400.svg';
import horizontalLinePhone from './horizontal-phone.svg';

const LineIcons = {
    verticalLine: verticalLine,
    horizontalLineW400: horizontalLine,
    horizontalLinePhone: horizontalLinePhone
}

export default LineIcons;